import { Form, Formik, useFormikContext } from "formik";
import { useEffect, useState } from "react";
import FormikInput from "../../../components/FormikInput";
import FormikSelect from "../../../components/FormikSelect";
import { fetchStates } from "../../../api/states";
import { fetchCities } from "../../../api/cities";
import http from "../../../plugins/http";
import Loading from "../../../components/Loading";
import FormikInputMask from "../../../components/FormikInputMask";
import Schema from "../Schemas/Schema";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Message } from "primereact/message";
import { KeyFilterType } from "primereact/keyfilter";

function ModalRegisterCarrier({
  carrier,
  updated,
  banks,
  args,
}: {
  carrier?: any;
  updated?: any;
  banks: any;
  args?: any;
}) {
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [states, setStates] = useState<any[]>([]);
  const [cities, setCities] = useState<any[]>([]);
  const [schema, setSchema] = useState<any>(Schema);
  const [type, setType] = useState("");
  const numberFilter: KeyFilterType = "num";
  const types = [
    { label: "Dados Bancários", value: "bank" },
    { label: "Token(Mercado Pago ou Pagar.me)", value: "token" },
  ];

  function FormButtons() {
    const { submitForm } = useFormikContext();
    return (
      <div className="w-full flex justify-end p-4 gap-x-4">
        <Button onClick={toggle} disabled={loading} severity="danger">
          Cancelar
        </Button>
        <Button type="submit" onClick={submitForm} disabled={loading} severity="success">
          {loading && <Loading />}
          Incluir
        </Button>
      </div>
    );
  }

  const toggle = () => {
    setModal(!modal);
  };

  const initialValues = {
    name_company: "",
    cnpj_company: "",
    email: "",
    phone: "",
    mobile_phone: "",
    inscricao_estadual: "",
    id_state: "",
    id_city: "",
    spreadsheet_url: "",
    nfe_percentage: "",
    max_weight: "",
    id_finance_type: "",
    bank_name: "",
    bank_agency: "",
    bank_account: "",
    token: "",
  };

  async function stateSelected(id: number) {
    setLoading(true);
    initialValues.id_city = "";
    fetchCities({ id_state: id }).then(res => {
      setCities(res.data);
      setLoading(false);
    });
  }

  function showError(message: string) {
    setError(message);
    setTimeout(() => {
      setError("");
    }, 3000);
  }

  const handleTypeChange = (type: any) => {
    setType(type);
    if (type === "bank") {
      setSchema(
        Schema.shape({
          ...Schema.fields,
          bank_name: Schema.fields.bank_name.required("Banco é obrigatório"),
          bank_agency: Schema.fields.bank_agency.required("Agência é obrigatório"),
          bank_account: Schema.fields.bank_account.required("Conta é obrigatório"),
          token: Schema.fields.token,
        })
      );
    } else {
      setSchema(
        Schema.shape({
          ...Schema.fields,
          token: Schema.fields.token.required("Token é obrigatório"),
          bank_name: Schema.fields.bank_name,
          bank_agency: Schema.fields.bank_agency,
          bank_account: Schema.fields.bank_account,
        })
      );
    }
  };

  async function register(values: any) {
    try {
      setLoading(true);
      const response = await http.post("/v1/carriers", {
        ...values,
      });
      if (response.status === 200) {
        toggle();
        if (updated) updated();
      } else if (response.data.hasOwnProperty("error")) {
        showError(response.data.error.portuguese);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setLoading(true);
    fetchStates().then(res => {
      setStates(res.data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="inline-flex">
      <Button onClick={toggle} severity="success" size="small" style={{ height: "38px" }}>
        Novo cadastro
      </Button>
      <Dialog header="Cadastrar transportadora" maximizable onHide={toggle} visible={modal} {...args}>
        <Formik
          initialValues={initialValues}
          validationSchema={schema}
          onSubmit={(values, actions) => {
            console.log(values);
            register(values);
          }}
          key={"form-register-carriers"}
        >
          <>
            <Form
              className="flex flex-wrap space-y-6 p-10"
              style={type !== "" ? { height: "35rem", overflowY: "scroll" } : {}}
            >

              <div className="flex w-full space-x-10">
                <FormikInput
                  className="w-1/2"
                  name="name_company"
                  label="Nome/Razão Social"
                  placeholder="Digite o nome da empresa"
                />
                <FormikInputMask
                  mask="99.999.999/9999-99"
                  className="w-1/2"
                  name="cnpj_company"
                  label="CNPJ"
                  placeholder="Digite o CNPJ"
                />
              </div>
              <div className="flex w-full space-x-10">
                <FormikInput
                  className="w-1/2"
                  name="inscricao_estadual"
                  label="Inscrição Estadual"
                  placeholder="Digite a inscrição estadual"
                  keyfilter="int"
                />
                <FormikInput className="w-1/2" name="email" label="Email" placeholder="Digite o email" />
              </div>

              <div className="flex w-full space-x-10">
                <FormikInputMask
                  className="w-1/2"
                  name="phone"
                  mask="(99) 99999-9999"
                  label="Telefone"
                  placeholder="Digite o número de telefone"
                />
                <FormikInputMask
                  className="w-1/2"
                  name="mobile_phone"
                  mask="(99) 99999-9999"
                  label="Celular"
                  placeholder="Digite o número de celular"
                />
              </div>
              <div className="flex w-full space-x-10">
                <FormikSelect
                  label="Estado"
                  name="id_state"
                  className="w-1/2"
                  options={states?.map(state => ({ label: state?.name, value: state?.id }))}
                  onChange={e => stateSelected(parseInt(e))}
                />
                <FormikSelect
                  label="Cidade"
                  name="id_city"
                  className="w-1/2"
                  options={cities.length > 0 ? cities?.map(city => ({ label: city.name, value: city.id })) : []}
                />
              </div>
              <div className="flex w-full space-x-10">
                <FormikInput
                  className="w-full"
                  name="spreadsheet_url"
                  label="Planilha"
                  placeholder="Ex: https://docs.google.com/spreadsheets/d/..."
                />
              </div>
              <div className="flex-grow h-px w-px bg-[#85d46c]"></div>
              <div className="flex w-full space-x-10">
                <h3>Dados Financeiros</h3>
              </div>
              <div className="flex w-full space-x-10">
                <FormikInput
                  className="w-1/2"
                  name="nfe_percentage"
                  label="Porcentagem sobre a NFE"
                  keyfilter={numberFilter}
                  placeholder="Insira a porcentagem sobre a NFE"
                />
                <FormikInput
                  className="w-1/2"
                  name="max_weight"
                  label="Peso máximo(kg)(Opcional)"
                  keyfilter={numberFilter}
                  placeholder="Insira o peso máximo"
                />
              </div>
              <div className="flex w-full space-x-10">
                <FormikSelect
                  label="Tipo"
                  name="id_finance_type"
                  className="w-1/2"
                  options={types}
                  placeholder="Selecione o tipo"
                  onChange={handleTypeChange}
                />
                <div className="w-1/2"></div>
              </div>
              {type === "token" && (
                <>
                  <div className="flex w-full space-x-10">
                    <FormikInput className="w-full" name="token" label="Código" placeholder="Digite o código" />
                  </div>
                </>
              )}
              {type === "bank" && (
                <>
                  <div className="flex w-full space-x-10">
                    <FormikSelect
                      className="w-1/2"
                      name="bank_name"
                      label="Banco"
                      placeholder="Selecione o banco"
                      options={banks}
                    />
                    <div className="w-1/2"></div>
                  </div>
                  <div className="flex w-full space-x-10">
                    <FormikInput className="w-1/2" name="bank_agency" label="Agência" placeholder="Digite a agência" />
                    <FormikInput className="w-1/2" name="bank_account" label="Conta" placeholder="Digite a conta" />
                  </div>
                </>
              )}
            </Form>
            <FormButtons />
            {error !== "" && <Message text={error} className="w-full mt-4" severity="error" />}
          </>
        </Formik>
      </Dialog>
    </div>
  );
}

export default ModalRegisterCarrier;
